// @ts-nocheck



import CommonApi from './../commonApi';

const assignmentLimitGroup = new CommonApi(
  'assignmentLimitGroup',
  'группы закрепления'
);

export default assignmentLimitGroup;
